/** Defines the content access level */
export var AccessLevel;
(function (AccessLevel) {
    /** Public */
    AccessLevel["Public"] = "PUBLIC";
    /** Restricted */
    AccessLevel["Restricted"] = "RESTRICTED";
    /** Private or hidden */
    AccessLevel["None"] = "NONE";
})(AccessLevel || (AccessLevel = {}));
/** Defines how the assistant is rendered */
export var AssistantDisplayType;
(function (AssistantDisplayType) {
    /** Rendered as full height */
    AssistantDisplayType["Full"] = "FULL";
    /** Rendered as compressed */
    AssistantDisplayType["Compressed"] = "COMPRESSED";
    /** Rendered as full height and compressed */
    AssistantDisplayType["Pushin"] = "PUSHIN";
})(AssistantDisplayType || (AssistantDisplayType = {}));
/** Defines the side of the page where the assistant is placed */
export var AssistantSide;
(function (AssistantSide) {
    /** Placed on the left */
    AssistantSide["Left"] = "LEFT";
    /** Placed on the right */
    AssistantSide["Right"] = "RIGHT";
})(AssistantSide || (AssistantSide = {}));
/** Defines how a walkthrough step is rendered */
export var DisplayType;
(function (DisplayType) {
    /** Rendered as a modal */
    DisplayType["Modal"] = "MODAL";
    /** Rendered as a tooltip */
    DisplayType["Tooltip"] = "TOOLTIP";
})(DisplayType || (DisplayType = {}));
/** Defines the KCS resolution/reply mode */
export var KcsMode;
(function (KcsMode) {
    /** Resolution mode */
    KcsMode["Resolve"] = "RESOLVE";
    /** Reply mode */
    KcsMode["Reply"] = "REPLY";
})(KcsMode || (KcsMode = {}));
/** Defines positioning options of an element */
export var PlacementType;
(function (PlacementType) {
    /** Top */
    PlacementType["T"] = "T";
    /** Top left */
    PlacementType["Tl"] = "TL";
    /** Top right */
    PlacementType["Tr"] = "TR";
    /** Bottom */
    PlacementType["B"] = "B";
    /** Bottom left */
    PlacementType["Bl"] = "BL";
    /** Bottom right */
    PlacementType["Br"] = "BR";
    /** Left */
    PlacementType["L"] = "L";
    /** Right */
    PlacementType["R"] = "R";
    /** Centre */
    PlacementType["C"] = "C";
})(PlacementType || (PlacementType = {}));
/** Defines the content restriction level */
export var RestrictionLevel;
(function (RestrictionLevel) {
    /** Unrestricted */
    RestrictionLevel["Unrestricted"] = "UNRESTRICTED";
    /** Restricted */
    RestrictionLevel["Restricted"] = "RESTRICTED";
})(RestrictionLevel || (RestrictionLevel = {}));
//# sourceMappingURL=grappa.js.map